import { createContext } from "react";
import type { AssistantType } from "../../types/assistant";

/** Which corpus the chat is querying. Read by message components to label feedback
 *  and to pick the right citation-resolution strategy in AssistantMarkdown. */
export const AssistantTypeContext = createContext<AssistantType>("spaces");
